/**
 * Business facts single source of truth.
 *
 * Hours confirmed by owner 2026-07-29 (Mon–Sat · 7am–6pm PT).
 * Keep in sync with the Google Business Profile if hours ever change.
 */


export const PHONE_DISPLAY = "(310) 850-7223";
export const PHONE_E164 = "+13108507223";
export const PHONE_HREF = `tel:${PHONE_E164}`;

export const ADDRESS = {
  streetAddress: "2620 E Foothill Blvd",
  addressLocality: "Pasadena",
  addressRegion: "CA",
  postalCode: "91107",
  addressCountry: "US",
} as const;

/**
 * Weekly hours as a schema.org OpeningHoursSpecification-compatible list.
 * Days use full names ("Monday"), times use 24h "HH:MM" strings.
 * Seeded from ContactPage display: Mon–Sat · 7am – 6pm PT.
 */
export const HOURS = [
  {
    dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    opens: "07:00",
    closes: "18:00",
  },
] as const;

/** Short human-readable label used in the UI. */
export const HOURS_DISPLAY = "Mon–Sat · 7am – 6pm PT";
